// extracted by mini-css-extract-plugin
export default {"scope":"_28Fpq","title":"_2smmC","message":"CU64y"};